<!--
  author:
  des:
  param:
-->
<template>
  <div class="info-container">
    <div class="b-title">一秒获取留学方案</div>
    <div class="at-section">
      <Select @chooseV="bindC" :list="country" contextP="选择想去的国家" :error="errorC"></Select>
      <Select @chooseV="bindY" :list="year" contextP="计划出国时间" :error="errorY"></Select>
      <Select @chooseV="bindG" :list="grade" contextP="选择目前就读年级" :error="errorG"></Select>
      <div class="form-group" style="margin-bottom: 10px" @click="submit">
        <a class="btn regist_and_getPlan" onclick="log('send','click','knowledge_countrylist','free_plan','click')">获取留学方案</a>
      </div>
      <div class="bottom-hint">已有<span>{{alloOffer}}</span>人获得方案</div>
    </div>
  </div>
</template>

<script>
  import Select from './select.vue'
  import { getpalanlist, getpalan, getarticle }  from '../../libs/api'
  export default {
    name: 'OneStep',
    data () {
      return {
        country: [],
        grade: [],
        year: [],
        form: {},
        errorC: '',
        errorY: '',
        errorG: '',
        alloOffer: 100120
      }
    },
    created () {
      this.getPlanList()
      this.getNum()
    },
    methods: {
      getNum () {
        getarticle().then((res)=> {
          this.alloOffer = res.data['common_all_offer'][0].title || '100120'
        }, (err) => {
          console.log(err)
        })
      },
      getPlanList () {
        getpalanlist().then((res) => {
          this.country = this.transformObj(res.data.data.country.list, 'id', 'value', 'key', 'value')
          this.grade = this.transformObj(res.data.data.grade.list, 'id', 'value', 'key', 'value')
          this.year = this.transformObj(res.data.data.year.list, 'code', 'name', 'key', 'value')
        }, () => {
          console.log(err)
        })
      },
      bindC (item) {
        this.form.hopeCountry = item.key
        this.errorC = ''
      },
      bindY (item) {
        this.form.hopeYear = item.key
        this.errorY = ''
      },
      bindG (item) {
        this.form.attendGrade = item.key
        this.errorG = ''
      },
      submit () {
        if (!this.form.hopeCountry) {
          this.errorC = '请选择想去的国家'
        } else if (!this.form.hopeYear) {
          this.errorY = '请选择出国时间'
        } else if (!this.form.attendGrade){
          this.errorG = '请选择就读年级'
        }
        if (Object.values(this.form).length < 3) return

        const param = {
          grade_course_major: this.form.attendGrade,
          hope_in_year: this.form.hopeYear,
          hope_in_section: '',
          hope_in_country: this.form.hopeCountry
        }
//        getpalan(param).then((res)=> {
//          console.log(res)
//        }, (err)=>{
//          console.log(err)
//        })
        window.open('//www.' + window.root_domain + '/threeSteps/twoStepUnregister.html?hopeYear='
          + this.form.hopeYear
          + '&index=redirect&hopeCountry='
          + this.form.hopeCountry +
          '&attendGrade=' + this.form.attendGrade);
      },
      transformObj (obj, key, value, newKey, newValue) {
        if (typeof obj === 'object') {
          if (Array.isArray(obj)) {
            return obj.map((v, i) => this.transformObj(v, key, value, newKey, newValue))
          } else {
            let newO = {}
            Object.keys(obj).map((_key, i) => {
              if (_key === key) {
                newO[newKey] = obj[_key]
              } else if (_key === value) {
                newO[newValue] = obj[_key]
              }
            })
            return newO
          }
        } else {
          return obj
        }
      }
    },
    components: {
      Select
    }
  }
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
  .info-container {
    width: 100%;
    background-color: #ffffff;
    border: 1px solid #e2e8ee;
    .b-title {
      color: #333;
      font-size: 16px;
      padding: 15px 0 15px 20px;
      border-bottom: 1px solid #e2e8ee;
    }
    .at-section {
      padding: 20px;
      font-size: 12px;
    }
    .form-group {
      margin-bottom: 25px;
      position: relative;
      .input-control {
        background-color: #fff;
        height: 32px;
        line-height: 32px;
        width: 100%;
        border: 1px solid #c6c9cc;
        color: #cdcdcd;
        cursor: pointer;
        display: block;
        font-size: 12px;
        padding: 0 6px;
        position: relative;
        &::after {
          border-left: 5px solid transparent;
          border-right: 5px solid transparent;
          border-top: 5px solid;
          display: inline-block;
          height: 0;
          margin-left: 2px;
          vertical-align: middle;
          width: 0;
          content: '';
          position: absolute;
          right: 10px;
          top: 50%;
          transform: translateY(-50%);
        }
      }
      .dropdown-menu {
        top: 33px;
        width: 100%;
        border: 1px solid #c6c9cc;
        border-top: none;
        color: #cdcdcd;
        cursor: pointer;
        font-size: 12px;
        line-height: 24px;
        max-height: 240px;
        overflow-y: auto;
        li {
          height: 30px;
          line-height: 30px;
          padding: 0 6px;
          &:hover {
            background-color: #eeeeee;
          }
        }
      }
      .btn {
        border: 1px solid transparent;
        border-radius: 4px;
        cursor: pointer;
        display: inline-block;
        margin-bottom: 0;
        vertical-align: middle;
        white-space: nowrap;
        background-color: #ff9c00;
        color: #fff;
        font-size: 16px;
        font-weight: 700;
        height: 42px;
        line-height: 42px;
        padding: 0;
        text-align: center;
        width: 100%;
        &:hover {
          background-color: #f78400;
        }
      }
    }
    .bottom-hint {
      font-size: 14px;
      color: #818181;
      text-align: center;
      span {
        color: #fd9b27;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/common/oneStep.vue